import React from 'react'
import { Animated, StyleSheet, View } from 'react-native'
import { RectButton, Swipeable } from 'react-native-gesture-handler'
import { dynamicSize } from '../../utils/hooks'

const SwipableItem = ({
  children,
  leftActionWidth,
  rightActionWidth,
  rightActions,
  leftActions,
  rightActionStyle,
  leftActionStyle,
}) => {
  let _swipeableRow

  // closes the swipable
  const close = () => {
    _swipeableRow.close()
  }

  // render single right action
  const renderRightAction = (content, color, handler, index) => {
    return (
      <Animated.View
        key={index}
        style={{ flex: 1, transform: [{ translateX: 0 }] }}
      >
        <RectButton
          style={[styles.action, { backgroundColor: '#FFF' }, rightActionStyle]}
          onPress={() => {
            close()
            handler()
          }}
        >
          {content}
        </RectButton>
      </Animated.View>
    )
  }

  // render single left action
  const renderLeftAction = (content, color, handler, index) => {
    return (
      <Animated.View
        key={index}
        style={{ flex: 1, transform: [{ translateX: 0 }] }}
      >
        <RectButton
          style={[styles.action, { backgroundColor: color }, leftActionStyle]}
          onPress={() => {
            close()
            handler()
          }}
        >
          {content}
        </RectButton>
      </Animated.View>
    )
  }

  // right actions to the list item
  const renderRightActions = () => (
    <View style={{ width: rightActionWidth, flexDirection: 'row' }}>
      {rightActions.map((action, index) => {
        const { icon, backgroundColor = '#DB2424', handler } = action
        return renderRightAction(icon, backgroundColor, handler, index)
      })}
    </View>
  )

  // left actions to the list item
  const renderLeftActions = () => (
    <View style={{ width: leftActionWidth, flexDirection: 'row' }}>
      {leftActions.map((action, index) => {
        const { icon, backgroundColor = '#DB2424', handler } = action
        return renderLeftAction(icon, backgroundColor, handler, index)
      })}
    </View>
  )
  const updateRef = (ref) => {
    _swipeableRow = ref
  }

  return (
    <Swipeable
      ref={updateRef}
      friction={8}
      leftThreshold={0}
      rightThreshold={0}
      overshootLeft={false}
      overshootRight={false}
      renderLeftActions={renderLeftActions}
      renderRightActions={renderRightActions}
    >
      {children}
    </Swipeable>
  )
}

const styles = StyleSheet.create({
  action: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
})

export default function SwipableListItem({
  leftActionWidth = dynamicSize(80),
  rightActionWidth = dynamicSize(80),
  rightActions = [],
  leftActions = [],
  rightActionStyle = {},
  leftActionStyle = {},
  children,
}) {
  return (
    <>
      <SwipableItem
        leftActionWidth={leftActions.length * leftActionWidth}
        rightActionWidth={rightActions.length * rightActionWidth}
        rightActions={rightActions}
        leftActions={leftActions}
        rightActionStyle={rightActionStyle}
        leftActionStyle={leftActionStyle}
      >
        {children}
      </SwipableItem>
    </>
  )
}
